<template>
  <v-card class="onboarding_card">
    <v-container class="container_detail">
      <img
        v-for="(item, i) in items"
        :key="i"
        :src="require('@/assets/images/onboarding/' + item.icon + '.svg')"
        style="display: none"
      />
      <v-carousel
        v-model="currentSlide"
        :cycle="true"
        height="auto"
        :interval="intervalTime"
        :show-arrows="false"
        hide-delimiters
        class="onboarding_carousel"
      >
        <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
          <v-sheet>
            <v-row
              class="container_onboarding_slide"
              align="center"
              justify="center"
            >
              <div class="onboarding_slide">
                <div class="onboarding_slide_icon">
                  <img
                    :src="
                      require('@/assets/images/onboarding/' +
                        item.icon +
                        '.svg')
                    "
                    :alt="item.icon"
                    loading="lazy"
                  />
                </div>
                <div class="onboarding_slide_title">{{ item.title }}</div>
                <div class="onboarding_slide_text" v-html="item.text"></div>
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>

      <v-row justify="space-between" class="white-background">
        <v-col cols="6" class="circles">
          <v-btn
            v-for="(item, i) in items"
            :key="i"
            icon
            @click="currentSlide = i"
          >
            <v-icon
              class="icon_detail"
              :color="currentSlide === i ? 'blue' : ''"
            >
              mdi-circle
            </v-icon>
          </v-btn>
        </v-col>

        <v-col cols="6" class="container-next-prev">
          <v-btn
            :class="{ 'blue-background': isPrevButtonBlue, prev_button: true }"
            icon
            @click="prevSlide"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            :class="{ 'blue-background': isNextButtonBlue, next_button: true }"
            icon
            @click="nextSlide"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "OnboardingCarousel",
  data: () => ({
    isPrevButtonBlue: false,
    isNextButtonBlue: false,
    currentSlide: 0,
    intervalTime: 4000,
    items: [
      {
        icon: "onboarding_icon_1",
        title: "¡Regístrate o ingresa!",
        text:
          "Para rendir el examen diagnóstico y luego matricularte, por favor <strong>REGÍSTRATE</strong>. Si ya tienes cuenta UP, solo debes <strong>INICIAR SESIÓN</strong> con tu mismo usuario y contraseña.",
      },
      {
        icon: "onboarding_icon_2",
        title: "¡Selecciona el idioma Ingles!",
        text:
          'Dirígete a “<strong>Aprender un nuevo idioma</strong>” y haz clic en “<strong>INGLÉS</strong>”, luego selecciona el programa o curso de tu preferencia.',
      },
      {
        icon: "onboarding_icon_3",
        title: "¡Es tiempo de dar tu examen!",
        text:
          "Selecciona “<strong>Iniciar examen</strong>” para rendir el examen diagnóstico sin costo alguno.",
      },
      {
        icon: "onboarding_icon_4",
        title: "¡Un Asesor te contactara!",
        text:
          "Dependiendo del programa o curso un asesor pedagógico se comunicará contigo mediante una llamada. Elige fecha y hora.",
      },
      {
        icon: "onboarding_icon_5",
        title: "¡Ahora vamos a matricularnos!",
        text:
          "Con los resultados estarás habilitado para matricularte.",
      },
      {
        icon: "onboarding_icon_6",
        title: "¡Ahora realiza el pago!",
        text:
          "Desde nuestra pagina “<strong>Matricula Online</strong>”, banca móvil, banca por internet de tu banco o una agencia bancaria.",
      },
    ],
  }),
  methods: {
    nextSlide() {
      this.isPrevButtonBlue = false;
      this.isNextButtonBlue = true;
      this.currentSlide = (this.currentSlide + 1) % this.items.length;
    },
    prevSlide() {
      this.isPrevButtonBlue = true;
      this.isNextButtonBlue = false;
      this.currentSlide =
        (this.currentSlide - 1 + this.items.length) % this.items.length;
    },
  },
};
</script>

<style lang="scss">
.v-application .blue--text {
  color: #0063ff !important;
  caret-color: #0063ff !important;
}
</style>
